import { PageController } from '@client/components/_core/layout/PageController';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { claimFormStore } from '@client/routes/~console.$orgId/~claims/~details.$id/store';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useEffect } from 'react';
import { z } from 'zod';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/comms/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New communication',
        },
    },
    validateSearch: zodValidator(
        z.object({
            email: z.string().optional().catch(undefined),
            phone: z.string().optional().catch(undefined),
        }),
    ),
    component: RouteComponent,
});

function RouteComponent() {
    const isReadonly = claimFormStore.use.isReadonly();
    const navigate = useNavigate();

    // CUR-725: closed claims are read-only — no new communications.
    useEffect(() => {
        if (isReadonly) {
            navigate({ moveInMatches: -1 });
        }
    }, [isReadonly]);

    return (
        <PageController route={Route}>
            <Outlet />
        </PageController>
    );
}
